import qs from 'querystring'
 
import _ from 'underscore'
import Api from '../lib/request'
import {
  itemList
} from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

const getActList = (options) => {
  return new Promise((resolve, reject) => {
    const query = `?${qs.stringify(options)}`
    const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`

    // Api.get('http://localhost:3000/activeList', {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.group.recommend-list',
      }
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const getGroupInfo = (productId) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}?productId=${productId}`
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.group.info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then(data => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      return resolve(data.data)
    })
  })
}

const getHotActiveGroupList = ({
  pageNum,
  pageSize
}) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}?pageNum=${pageNum}&pageSize=${pageSize}`
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.act.group-act.hot-group-active',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then(data => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      return resolve(data.data)
    })
  })
}
const getHomeRecommendItems = () => {
  return new Promise((resolve, reject) => {
    Api.get(`/api/recommend/home`)
      .then((data) => {
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}


const getMoreGroup = (data) => {
  // return Promise.resolve(mockData2.data)
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`
    }
    let url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
    // url = 'http://localhost:3000/groupList'
    Api.get(url, {
        headers: {
          'X-Host': 'mall.group.group-list',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status == 6003) {
            return resolve([])
          } else if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}

const getBubbleList = (productId) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isUndefined(productId)) {
      query = `?productId=${productId}`
    }
    const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
    // Api.get('http://localhost:3000/bubbleList', {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.group.dynamic-group-info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const getGroupUser = (groupCode) => {
  return new Promise((resolve, reject) => {
    const url = `${COOKIECONSTANT.REQUEST_HOST}?groupCode=${groupCode}`
    // Api.get('http://localhost:3000/groupUser', {
    Api.get(url, {
        headers: {
          'X-Host': 'mall.group.group-user',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status == 6666) {
            return toLogin()
          } else if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
/*yeoman-template-point-1*/
export default {
  getActList,
  getGroupInfo,
  getHotActiveGroupList,
  getHomeRecommendItems,
  getMoreGroup,
  getGroupUser,
  getBubbleList
  /*yeoman-template-point-2*/
}
